import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  submit: {
    margin: theme.spacing(8, 0, 2),
    padding: theme.spacing(1.5, 2),
  },
}));
